import React from "react";
import classnames from "classnames";

export default function EventContentToggleButton({
	title,
	isActive,
	isDisabled,
	onClick,
}: {
	title: string;
	isActive: boolean;
	isDisabled?: boolean;
	onClick: () => void;
}) {
	const buttonClassName = classnames(
		"at-showBets tabs--primary__item tabs--primary--bordered__item u-display--f--grow",
		{
			"is-active": isActive,
			"is-disabled": isDisabled,
		}
	);

	return (
		<button
			type="button"
			disabled={isDisabled}
			onClick={onClick}
			className={buttonClassName}
		>
			{title}
		</button>
	);
}
